import { render, staticRenderFns } from "./ui-upload.vue?vue&type=template&id=680d9a46&scoped=true"
import script from "./ui-upload.vue?vue&type=script&lang=js"
export * from "./ui-upload.vue?vue&type=script&lang=js"
import style0 from "./ui-upload.vue?vue&type=style&index=0&id=680d9a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d9a46",
  null
  
)

export default component.exports